import axios from 'axios'
import { host } from '../../helper/config'

const PLUGIN_NAME = 'admin-charge-user'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  Authorization: token,
})

async function post(token, path, body = {}) {
  try {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/${path}`, body, {
      headers: headers(token),
    })
    if (response && response.status === 200) {
      return { ok: true, data: response.data }
    }
    return { ok: false, message: 'Request failed' }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Có lỗi xảy ra'
    return { ok: false, message }
  }
}

export const getAllChargeUsers = async (token) => {
  const result = await post(token, 'get-all')
  if (result.ok) {
    return result.data || {}
  }
  return { error: true, message: result.message }
}

export const addChargeUser = async (token, payload) => {
  const result = await post(token, 'add', payload)
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const updateChargeUser = async (token, payload) => {
  const result = await post(token, 'update', payload)
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const updateChargeUserStatus = async (token, id, status) => {
  const result = await post(token, 'update-status', { id, status: parseInt(status, 10) })
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const resetChargeUserPassword = async (token, id, password) => {
  const result = await post(token, 'reset-password', { id, password })
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const deleteChargeUser = async (token, id) => {
  const result = await post(token, 'delete', { id })
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}
